import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import SuneethaKasani from "../Assets/SuneethaKasani.jpg";
import UseScrollAnimation from "../Elements/ScrollAnimation";
import ReadySchedule from "./Page_Sections/readySchedule";
import AboutThePractitioner from "./Page_Sections/aboutThePractitioner";
// import ThreeTestimonials from "./Page_Sections/threeTestimonials";

const YourPractitioner = () => {
  UseScrollAnimation();

  return (
    <>
      <div className="HomeParent">
        <div className="HomeBox">
          {/* HERO SECTION */}
          <section className="GentleRemedies_Section">
            <div className="GentleRemedies_SectionParent">
              <div className="GentleRemedies_SectionBox">
                <p className="GentleRemedies_Section_Title animate-top">
                  Your Practitioner
                </p>

                <h1 className="GentleRemedies_Section_Heading animate-top">
                  A practice of
                  <br />
                  <span className="GentleRemedies_Section_HeadingItalic">
                    patient listening.
                  </span>
                </h1>

                <p className="GentleRemedies_Section_Content animate-top">
                  {/* Over 25 years of classical homeopathic experience, dedicated
                  to walking beside each client on their unique path back to
                  wholeness. */}
                  With extensive experience in classical homeopathy, I am
                  dedicated to walking beside each client on their unique path
                  towards holistic well-being.
                </p>

                <div className="GentleRemedies_Section_Buttons animate-top">
                  <Link
                    to="/contact-us"
                    className="GentleRemedies_Section_Button01"
                  >
                    {/* <span>Schedule a Consultation</span> */}
                    <span>Book Appointment Today</span>
                    <ArrowRight className="GentleRemedies_Section_Button01_ArrowRight" />
                  </Link>
                </div>
                <div className="GentleRemedies_Section_Buttons GentleRemedies_Section_Buttons00 animate-top">
                  <div className="GentleRemedies_Section_ContentButtons">
                    <span className="GentleRemedies_Section_Content">
                      In-person and tele-health services
                    </span>

                    <Link
                      to="/services"
                      className="GentleRemedies_Section_Button02 animate-top"
                    >
                      Explore Services
                      <ArrowRight className="GentleRemedies_Section_Button01_ArrowRight" />
                    </Link>
                  </div>
                  {/* <div className="CCHandNASH_LogoDiv">
                  <img
                    src={CCH_Logo}
                    alt="CCH_Logo"
                    className="CCH_Logo"
                    fetchPriority="high"
                    loading="eager"
                  />
                  <img
                    src={NASH_Logo}
                    alt="NASH_Logo"
                    className="NASH_Logo"
                    fetchPriority="high"
                    loading="eager"
                  />
                </div> */}
                </div>
              </div>
              <div
                initial="hidden"
                animate="show"
                className="GentleRemedies_ImageHighlight"
              >
                <div className="Practitioner_ImageDiv00">
                  <img
                    src={SuneethaKasani}
                    alt="Practitioner"
                    className="Practitioner_Image00 animate-top"
                    loading="eager" // 👈 important image (hero)
                  />
                </div>
                {/* <figure
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6, duration: 0.7 }}
                  className="GentleRemedies_Section_Highest animate-top"
                >
                  <Quote className="GentleRemedies_Section_HighestIcon" />
                  <blockquote className="GentleRemedies_Section_HighestContent">
                    "The highest ideal of heal is rapid, gentle and permanent
                    restoration of health."
                  </blockquote>
                  <figcaption className="GentleRemedies_Section_HighestName">
                    — Suneetha Kasani
                  </figcaption>
                </figure> */}
              </div>
            </div>
          </section>

          {/* ABOUT SECTION */}
          <AboutThePractitioner />

          <ReadySchedule />
          {/* <ThreeTestimonials /> */}
        </div>
      </div>
    </>
  );
};

export default YourPractitioner;
